export default "__VITE_ASSET__B_twRX_D__"